import moment from 'moment'

export default {
  getList (VueApp, callback) {
    let self = this
    let consumers = VueApp.$store.state.consumer.users

    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: consumers.currentPage,
      pageSize: consumers.perPage,
      order: consumers.order,
      orderAsc: consumers.orderAsc,
      search: consumers.search
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setUserMaxList', res.paging.totalItems)

        if (res.list.length) {
          let users = []
          for (let i = 0; i < res.list.length; i++) {
            let userInfo = res.list[i]
            let created = moment(userInfo.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY')
            if (userInfo.created === null) { created = 'N/A' }
            let phone = userInfo.phone ? userInfo.countryCode + '' + userInfo.phone : ''
            users.push({
              id: userInfo.ID,
              firstName: userInfo.firstName,
              lastName: userInfo.lastName,
              email: userInfo.email,
              mobile: phone,
              created: created,
              referralCode: userInfo.referralCode,
              status: self.statusLabel(userInfo),
              customerURL: userInfo.customerURL,
              countryCode: userInfo.countryCode,
              nationalNumber: userInfo.nationalNumber || userInfo.phone
            })
          }

          VueApp.$store.commit('consumer/addUser', users)
        }
      }
      callback(res)
    })
  },
  statusLabel (data) {
    if (data.verified === 0) { return 'unverified' }
    if (data.enabled === 0) { return 'disabled' }
    return 'active'
  },
  export (VueApp, callback) {
    let self = this
    let consumers = VueApp.$store.state.consumer.users

    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: consumers.currentPage,
      pageSize: consumers.perPage,
      order: consumers.order,
      orderAsc: consumers.orderAsc,
      search: consumers.search
    }, res => {
      if (!res.error) {
        let cons = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            cons.push(self.buildExportAll(value))
          })
        }
        callback(cons)
      } else {
        callback(res)
      }
    })
  },
  buildExportAll (data) {
    let self = this
    let created = ''
    if (data.created) {
      let temp = moment(data.created, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        created = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }

    let phone = `+${data.countryCode} ${data.nationalNumber || data.phone}`
    return {
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': phone,
      'Created Date': created,
      'Referral Code': data.referralCode,
      'Status': self.statusLabel(data),
      'Stripe Link': data.customerURL
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/list.js